/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import "./style.less";
import { Link, useLocation } from "react-router-dom";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import logo from "@/assets/Logo.png";
import useWindowScrollHeight from "@/hooks/useWindowScrollHeight";
import { NAV_LINKS, isNavActive } from "@/constants/navigation";
import { scrollWindowToTop } from "@/utils/scroll";

const NavBar = () => {
  const scrollHeight = useWindowScrollHeight();
  const location = useLocation();
  const pathName = location?.pathname;
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathName]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <div className={`nav_bar ${scrollHeight > 0 ? "window_scroll" : ""}`}>
      <div className="nav_warp">
        <div className="logo">
          <Link
            to="/"
            onClick={() => {
              setMenuOpen(false);
              scrollWindowToTop();
            }}
          >
            <img src={logo} alt="Highdim Smart" />
          </Link>
        </div>

        <button
          type="button"
          className="nav_toggle"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          {menuOpen ? <AiOutlineClose /> : <AiOutlineMenu />}
        </button>

        <div className={`nav_list ${menuOpen ? "nav_list--open" : ""}`}>
          {NAV_LINKS.map((item) => (
            <div className="nav_item" key={item.key}>
              <div className="nav_item_content">
                <Link
                  to={item.path}
                  className={isNavActive(pathName, item.key) ? "active" : ""}
                  onClick={() => {
                    setMenuOpen(false);
                    scrollWindowToTop();
                  }}
                >
                  {item.name}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      {menuOpen && (
        <button
          type="button"
          className="nav_overlay"
          aria-label="Close menu"
          onClick={() => setMenuOpen(false)}
        />
      )}
    </div>
  );
};

export default NavBar;
